import { render } from "./B2bSendCover.vue?vue&type=template&id=292dce17&scoped=true&lang=pug"
import script from "./B2bSendCover.vue?vue&type=script&lang=js"
export * from "./B2bSendCover.vue?vue&type=script&lang=js"

import "./B2bSendCover.vue?vue&type=style&index=0&id=292dce17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292dce17"]])

export default __exports__